export const DESK_HOME_LAYOUT_IDS = [
  "edgecaster",
  "tilt",
  "analyst",
  "stock",
] as const;

export type DeskHomeLayoutId = (typeof DESK_HOME_LAYOUT_IDS)[number];

export const MOBILE_DESK_HOME_LAYOUT_IDS = ["edgecaster", "analyst"] as const;

export type MobileDeskHomeLayoutId =
  (typeof MOBILE_DESK_HOME_LAYOUT_IDS)[number];

export interface DeskHomeLayoutOption {
  value: DeskHomeLayoutId;
  label: string;
  detail: string;
}

export interface MobileDeskHomeLayoutOption {
  value: MobileDeskHomeLayoutId;
  label: string;
  detail: string;
}

export const DEFAULT_DESK_HOME_LAYOUT: DeskHomeLayoutId = "edgecaster";
export const DEFAULT_MOBILE_DESK_HOME_LAYOUT: MobileDeskHomeLayoutId =
  "edgecaster";

export const DESK_HOME_LAYOUT_OPTIONS: DeskHomeLayoutOption[] = [
  {
    value: "edgecaster",
    label: "EdgeCaster",
    detail: "Desk Plan and EdgeCaster stay in the primary decision surface.",
  },
  {
    value: "tilt",
    label: "Tilt Correction",
    detail: "Pre-session checklist plus trader-specific ER controls.",
  },
  {
    value: "analyst",
    label: "Analyst",
    detail: "Risk signals, research context, and Forum/RiskFlow awareness.",
  },
  {
    value: "stock",
    label: "Stock Screener",
    detail: "Stock trader review with report-style handoff surfaces.",
  },
];

export const MOBILE_DESK_HOME_LAYOUT_OPTIONS: MobileDeskHomeLayoutOption[] = [
  {
    value: "edgecaster",
    label: "EdgeCaster",
    detail: "Desk plan, Edgeful timing, and same-window RiskFlow context.",
  },
  {
    value: "analyst",
    label: "Analyst",
    detail: "Risk signals, prices of interest, and instrument outlook.",
  },
];

export function isDeskHomeLayoutId(value: unknown): value is DeskHomeLayoutId {
  return (
    typeof value === "string" &&
    DESK_HOME_LAYOUT_IDS.includes(value as DeskHomeLayoutId)
  );
}

export function normalizeDeskHomeLayout(value: unknown): DeskHomeLayoutId {
  if (value === "current" || value === "decision-layer" || value === "full") {
    return DEFAULT_DESK_HOME_LAYOUT;
  }
  return isDeskHomeLayoutId(value) ? value : DEFAULT_DESK_HOME_LAYOUT;
}

export function isMobileDeskHomeLayoutId(
  value: unknown,
): value is MobileDeskHomeLayoutId {
  return (
    typeof value === "string" &&
    MOBILE_DESK_HOME_LAYOUT_IDS.includes(value as MobileDeskHomeLayoutId)
  );
}

export function normalizeMobileDeskHomeLayout(
  value: unknown,
): MobileDeskHomeLayoutId {
  return isMobileDeskHomeLayoutId(value)
    ? value
    : DEFAULT_MOBILE_DESK_HOME_LAYOUT;
}

export function getDeskHomeLayoutOption(layout: DeskHomeLayoutId) {
  return (
    DESK_HOME_LAYOUT_OPTIONS.find((option) => option.value === layout) ??
    DESK_HOME_LAYOUT_OPTIONS[0]
  );
}
